export enum DeveloperPaths {
  INDEX = "/buildings",
  NEWS = "/news",
  CREATEPOST = "/create_post",
  BUILDING_ID = "/buildings/:id/:name",
  EDIT = "/news/edit_post/:id",
}
